import React, {Fragment} from 'react';
import './Header.css';
import InfoBar from './BreadcrumbBar';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Image} from 'react-bootstrap';
import Logo from '../img/logo.png';

class Header extends React.Component {
  render() {
    return (
      <div>
        <div className="header">
          <Link className='mr-auto' to={'/'}>
           <Image src={Logo} height="44px" alt="" />
          </Link>
          <div className="nav">
            {
              this.props.auth.isAuthenticated &&
              <Fragment>
                <p data-cy='login-greetings' className='mr1 mb0'>Hello, { this.props.auth.userInfo.username }!</p>
                <Link to="/">Home</Link>
                {
                  this.props.auth.userInfo.attributes['custom:role'] === 'admin' &&
                    <Fragment>
                      <Link to="/users">Users</Link>
                      <Link to="/assessments">Assessments</Link>
                    </Fragment>
                }
                <a style={{ cursor: 'pointer' }} onClick={this.props.handleLogout}>Logout</a>
              </Fragment>
            }
            {
              !this.props.auth.isAuthenticated &&
              <Fragment>
                <Link to="/login">Login</Link>
              </Fragment>
            }
          </div>
        </div>
        <InfoBar/>
      </div>
    );
  }
}

Header.propTypes = {
  auth: PropTypes.shape({
    isAuthenticated: PropTypes.bool
  }),
  handleLogout: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js